import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { GrLogout } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import ThemeSpinner from "../ThemeComponent/ThemeSpinner";
import { success } from "../../utils/helpers.js";
import { useDispatch } from "react-redux";
import { unsetAuthInfo } from "../../Redux/Slice/authSlice";
import { removeAuthToken, removeToken } from "../../Redux/services/localStorageService.js";

const LogoutModal = ({ setLogoutModal }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleCancel = () => {
    setLogoutModal(false);
  };
  const handleLogout = () => {
    setIsLoading(true);
    setTimeout(() => {
      //   setIsLoading(false);
      //   setLogoutModal(false);
      //   dispatch(setUser(null));
      removeToken();
      removeAuthToken();
      dispatch(unsetAuthInfo({token: '', user: null}));
      navigate("/");
      success("Logged out successfully");
    }, 500);
  };
  return (
    <>
      <div className="logout-modal-content">
        {/* <Image src="/images/logout.svg" className="image-fluid mb-3 object-fit contain" width={50} height={50} priority /> */}
        <div className="flex-custom-center">
          <GrLogout size={40} className="mb-3" />
        </div>
        <div className="w-100 center-text">
          <h2>Are you Sure?</h2>
          <p>Are you sure you want to Logout?</p>
        </div>
        <div className="btn w-100">
          <Button className="cancel-btn w-100" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            disabled={isLoading}
            className="theme-btn cancel w-100 mt-3"
            onClick={handleLogout}
          >
            {isLoading ? <ThemeSpinner /> : "Logout"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default LogoutModal;
